<div class="docs-page" [attr.data-theme]="theme">
  <header class="docs-header">
    <a class="docs-logo" href="/">
      <span class="logo-pxl">pxl</span><span class="logo-vd">vd</span>
    </a>
    <nav class="docs-nav">
      <a href="/" class="docs-nav-link">← Back to Studio</a>
      <div class="theme-pill">
        <button [class.active]="theme === 'pxlvd'" (click)="setTheme('pxlvd')">pxlvd</button>
        <button [class.active]="theme === 'dark'"  (click)="setTheme('dark')">Dark</button>
        <button [class.active]="theme === 'light'" (click)="setTheme('light')">Light</button>
      </div>
    </nav>
  </header>

  <div class="docs-hero">
    <h1 class="docs-title">Documentation</h1>
    <p class="docs-sub">How to draw, animate, import and export, collaborate, and tune the workspace.</p>
    <div class="docs-search-wrap">
      <svg class="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      <input #docsSearchInput type="text" class="docs-search" [(ngModel)]="search" placeholder="Filter articles…">
      <kbd *ngIf="!search.trim()">Ctrl+K</kbd>
    </div>
  </div>

  <div class="docs-shell">
    <aside class="docs-sidebar" aria-label="Documentation sections">
      <button *ngFor="let s of sections" type="button" class="sidebar-link" [class.active]="activeSection === s"
        (click)="activeSection = s">
        {{ s | titlecase }}
      </button>
    </aside>

    <main class="docs-main">
      <p *ngIf="filtered.length > 0" class="docs-main-lead">
        <ng-container *ngIf="activeSection === 'all'">Browse by section, or filter with the search above.</ng-container>
        <ng-container *ngIf="activeSection !== 'all'">{{ sectionLabels[activeSection] || (activeSection | titlecase) }}</ng-container>
      </p>

      <div *ngIf="filtered.length === 0" class="docs-empty">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <p>No articles match “{{ search }}”. Try another word or clear the filter.</p>
      </div>

      <div class="docs-stream">
        <section *ngFor="let group of docGroups" class="docs-section"
          [attr.aria-labelledby]="showSectionHeadings ? 'sec-' + group.section : null"
          [attr.aria-label]="showSectionHeadings ? null : group.label">
          <h2 *ngIf="showSectionHeadings" class="docs-section-title" [id]="'sec-' + group.section">{{ group.label }}</h2>

          <article *ngFor="let doc of group.docs" class="doc-article" [id]="doc.id">
            <header class="doc-article-head">
              <h3 class="doc-article-title" [innerHTML]="highlight(doc.title)"></h3>
              <kbd *ngIf="doc.shortcut" class="doc-shortcut">{{ doc.shortcut }}</kbd>
            </header>
            <p class="doc-summary" [innerHTML]="highlight(doc.summary)"></p>
            <ul *ngIf="doc.bullets?.length" class="doc-bullets">
              <li *ngFor="let line of doc.bullets ?? []" [innerHTML]="highlight(line)"></li>
            </ul>
            <div class="doc-tags" *ngIf="doc.tags.length">
              <span *ngFor="let tag of doc.tags" class="doc-tag">{{ tag }}</span>
            </div>
          </article>
        </section>
      </div>
    </main>
  </div>
</div>
